import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";
import type { SubscriptionStatus } from "./constants";

interface SubscriptionStatusBadgeProps {
  readonly status: SubscriptionStatus;
  readonly testId?: string;
}

const STATUS_CLASS: Record<SubscriptionStatus, string> = {
  ACTIVE: "bg-emerald-100 text-emerald-800",
  TRIALING: "bg-sky-100 text-sky-800",
  PAST_DUE: "bg-destructive/10 text-destructive",
  PAUSED: "bg-amber-100 text-amber-800",
  INCOMPLETE: "bg-amber-100 text-amber-800",
  PENDING_ACTIVATION: "bg-muted text-muted-foreground",
  CANCELLED: "bg-muted text-muted-foreground",
};

export function SubscriptionStatusBadge({ status, testId }: SubscriptionStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 font-sans text-xs font-medium",
        STATUS_CLASS[status],
      )}
    >
      {t(`subscriptions.list.status.${status}`)}
    </span>
  );
}
